<template>
  <div class="referrals">
    <m-converted-bonuses
      :active="isShowConvertedBonusesModal"
      :count-bonuses-current="bonusesCountLocal"
      :bonuses-rate="bonusesRateLocal"
      @close="isShowConvertedBonusesModal = false"
      @convertBonusesToRub="convertBonusesToRub"
    />

    <m-link-to-fill-questionnaire
      :active="isShowLinkToQuestionnaireModal"
      @close="isShowLinkToQuestionnaireModal = false"
    />

    <m-brought-by-employee
      :active="isShowBroughtByEmployeeModal"
      :current-brought-employee="referralEmployeeNameLocal"
      @saveBroughtEmployee="saveBroughtEmployee"
      @close="isShowBroughtByEmployeeModal = false"
    />

    <div v-if="!isDataLoading" class="referrals-header">
      <div class="referrals-header-bonuses">
        <div class="referrals-header-bonuses-count">{{ bonusesCountLocal }}</div>
        <div class="referrals-header-bonuses-text">
          {{ declOfNum(bonusesCountLocal, ["бонус", "бонуса", "бонусов"]) }}
        </div>
        <c-button
          v-if="userHavePermissionConvertBonusesAndChangeInvitedWorker()"
          class="referrals-header-bonuses-convert"
          :disabled="bonusesCountLocal === 0"
          label="Конвертировать"
          @click="isShowConvertedBonusesModal = true"
        />
      </div>
      <div class="referrals-header-referral" :class="{ 'referrals-header-referral-empty': !referralEmployeeNameLocal }">
        <div class="referrals-header-referral-text">Приведен сотрудником</div>
        <div class="referrals-header-referral-employee">
          <router-link
            v-if="referralEmployeeNameLocal !== null"
            class="referrals-header-referral-employee-name"
            :to="{ name: 'personal-employee-referrals', params: { id: referralEmployeeNameLocal.value } }"
            target="_blank"
          >
            {{ referralEmployeeNameLocal.label }}
          </router-link>
          <c-button
            v-if="userHavePermissionConvertBonusesAndChangeInvitedWorker()"
            v-b-popover.html="{ container: '#app', trigger: 'hover blur', content: 'Редактировать', placement: 'top' }"
            class="referrals-header-referral-employee-edit"
            :class="{ 'referrals-header-referral-employee-edit-empty': !referralEmployeeNameLocal }"
            size="iconic"
            icon="edit"
            @click="isShowBroughtByEmployeeModal = true"
          />
        </div>
      </div>
      <c-button
        class="referrals-header-link-to-questionnaire"
        icon="link"
        size="small"
        label="Ссылка на заполнение анкеты"
        @click="isShowLinkToQuestionnaireModal = true"
      />
    </div>
    <div v-if="!isDataLoading && tableDataBroughtEmployees.records.length === 0" class="referrals-description">
      <p class="referrals-description-text">
        Для того чтобы привести своего друга в компанию, нужно отправить ему вашу уникальную ссылку на заполнение
        анкеты. Чтобы её скопировать, кликните по кнопке <b>«Ссылка на заполнение анкеты».</b>
      </p>
      <p class="referrals-description-text">
        За каждого приведенного кандидата и за каждое достижение приведенного сотрудника вам будут начисляться бонусы,
        которые затем можно конвертировать в {{currencyLabel}} и перевести на <b>личный счёт.</b>
      </p>
    </div>
    <div v-if="!isDataLoading && tableDataBroughtEmployees.records.length > 0" class="referrals-brought-employees">
      <div class="referrals-brought-employees-title">Приведенные сотрудники</div>
      <c-data-table-personal-employee
        id="broughtEmployees"
        ref="table"
        class="referrals-brought-employees-table"
        empty-records-label="Записи не найдены"
        :levels="1"
        :disabled-columns="[]"
        :data="tableDataBroughtEmployees"
      />
    </div>
    <div v-if="!isDataLoading && tableDataBroughtEmployees.records.length > 0" class="referrals-bonuses">
      <div class="referrals-bonuses-title">Бонусы</div>
      <div class="referrals-bonuses-filters">
        <c-input
          ref="referralsBonusesPeriod"
          v-model="periodLocal"
          class="referrals-bonuses-filters-period"
          :class="{
            'referrals-bonuses-filters-period-disabled':
              periodStart.length === 0 && periodEnd.length === 0 && tableDataHistoryBonuses.records.length === 0,
          }"
          label="За период"
          placeholder="00.00.0000 - 00.00.0000"
          type="period"
          icon="calendar"
          :clearable="true"
          :icon-right="true"
        />
        <c-button
          :disabled="periodStart.length === 0 && periodEnd.length === 0 && tableDataHistoryBonuses.records.length === 0"
          class="referrals-bonuses-filters-apply"
          label="Применить"
          color="primary"
          @click="applyFilters"
        />
      </div>
      <c-data-table-personal-employee
        v-if="tableDataHistoryBonuses.columns.length > 0"
        id="historyBonuses"
        ref="table"
        class="referrals-bonuses-table"
        empty-records-label="Бонусов пока не начислено"
        :levels="1"
        :disabled-columns="[]"
        :data="tableDataHistoryBonuses"
      />
    </div>
    <c-loader
      v-if="isDataLoading"
      class="referrals-loader"
      label="Данные загружаются"
      :active="isDataLoading"
      height="500"
    />
  </div>
</template>
<script>
import moment from "moment";
import { mapGetters } from "vuex";
import Button from "@/components/controls2/Button";
import DataTablePersonalEmployee from "@/pages/personal-employee/additions/data-table-personal-employee";
import Input from "@/components/controls2/Input";
import ConvertedBonusesModal from "@/pages/personal-employee/additions/modals/referrals-converted-bonuses-modal";
import LinkToFillQuestionnaireModal from "@/pages/personal-employee/additions/modals/referrals-link-to-fill-questionnaire-modal";
import BroughtByEmployeeModal from "@/pages/personal-employee/additions/modals/referrals-brought-by-employee-modal";
import Loader from "@/components/loader";

export default {
  name: "personal-employee-referrals",
  components: {
    "c-button": Button,
    "c-data-table-personal-employee": DataTablePersonalEmployee,
    "c-input": Input,
    "c-loader": Loader,
    "m-converted-bonuses": ConvertedBonusesModal,
    "m-link-to-fill-questionnaire": LinkToFillQuestionnaireModal,
    "m-brought-by-employee": BroughtByEmployeeModal,
  },

  data() {
    return {
      currencyLabel: '฿',
      isDataLoading: false,
      periodLocal: null,
      periodStart: this.$route.query.periodStart ? this.$route.query.periodStart : "",
      periodEnd: this.$route.query.periodEnd ? this.$route.query.periodEnd : "",
      isShowConvertedBonusesModal: false,
      referralEmployeeNameLocal: null,
      isShowLinkToQuestionnaireModal: false,
      bonusesCountLocal: 0,
      bonusesRateLocal: 1,
      isShowBroughtByEmployeeModal: false,
      tableDataBroughtEmployees: {
        type: "referrals-brought-employees",
        columns: [],
        records: [],
        actions: false,
        enabledFields: [],
        levels: 1,
        filteredColumns: [],
        activeFilteredColumns: [],
        globalFilters: [],
      },
      tableDataHistoryBonuses: {
        type: "referrals-history-bonuses",
        columns: [],
        records: [],
        actions: false,
        enabledFields: [],
        levels: 1,
        filteredColumns: [],
        activeFilteredColumns: [],
        globalFilters: [],
      },
    };
  },

  computed: {
    ...mapGetters("personalEmployee", [
      "getTableColumnsRefferalsBroughtEmployees",
      "getTableColumnsRefferalsHistoryBonuses",
    ]),
    ...mapGetters(["getUserPermissions"]),
  },

  mounted() {
    // setTimeout(() => {
    //   this.setPeriodLocal()
    // }, 500)
  },

  async created() {
    this.getCurrencyLabel();

    this.isDataLoading = true;

    const workerId = this.$route.params.id;
    const { userId } = this.$store.state;

    this.tableDataBroughtEmployees.columns = this.getTableColumnsRefferalsBroughtEmployees;
    await this.$store
      .dispatch("personalEmployee/getReferralsEmployeesList", {
        workerId,
        userId,
      })
      .then((res) => {
        if (res.status === 403) {
          this.$router
            .push({
              name: "error-403",
            })
            .catch(() => {});
        } else {
          this.bonusesCountLocal = res.response.bonuses;

          if (res.response.invitation_info.invited_by !== null) {
            this.referralEmployeeNameLocal = {
              value: res.response.invitation_info.invited_by.id,
              label: res.response.invitation_info.invited_by.name,
            };
          }
          this.bonusesRateLocal = res.response.bonus_rate;

          this.tableDataBroughtEmployees.records = res.response.invited_workers.map((worker) => ({
            name: {
              value: worker.name,
            },
            post: {
              value: worker.post,
            },
            filial: {
              value: worker.filial,
            },
            worksheet_date: {
              value: worker.worksheet_date,
            },
            hired_date: {
              value: worker.hired_date,
            },
            bonus: {
              value: worker.bonus,
            },
            workerId: worker.worker_id,
            accessToPersonal: worker.access_to_personal,
            isShowRow: true,
          }));
          // console.log(res)
        }
      });

    this.getReferralsHistoryBonusesList();
  },
  methods: {
    userHavePermissionConvertBonusesAndChangeInvitedWorker() {
      return (
        this.getUserPermissions.includes("updateAllInvitedWorkers") ||
        this.getUserPermissions.includes("workerBonusControl")
      );
    },

    getCurrencyLabel() {
      this.$store.dispatch("personalEmployee/getCurrencyLabel").then((result) => {
        this.currencyLabel = result;
      });
    },

    setPeriodLocal() {
      if (this.periodStart.length > 0 && this.periodEnd.length > 0) {
        this.$refs.referralsBonusesPeriod.period.start.input = this.periodStart;
        this.$refs.referralsBonusesPeriod.period.end.input = this.periodEnd;

        const period = `${this.periodStart}-${this.periodEnd}`;
        const today = moment().startOf("day").format("DD.MM.YYYY").toString();
        const yesterday = moment().startOf("day").subtract(1, "day").format("DD.MM.YYYY").toString();
        const firstDayCurrentWeek = moment().startOf("day").startOf("week").format("DD.MM.YYYY").toString();
        const lastDayCurrentWeek = moment().startOf("day").format("DD.MM.YYYY").toString();
        const firstDayLastWeek = moment()
          .startOf("day")
          .startOf("week")
          .subtract(1, "week")
          .format("DD.MM.YYYY")
          .toString();
        const lastDayLastWeek = moment()
          .startOf("day")
          .endOf("week")
          .subtract(1, "week")
          .format("DD.MM.YYYY")
          .toString();
        const sevenDayAgo = moment().startOf("day").subtract(6, "day").format("DD.MM.YYYY").toString();
        const firstDayCurrentMonth = moment().startOf("day").startOf("month").format("DD.MM.YYYY").toString();
        const firstDayLastMonth = moment()
          .startOf("day")
          .subtract(1, "month")
          .startOf("month")
          .format("DD.MM.YYYY")
          .toString();
        const lastDayLastMonth = moment()
          .startOf("day")
          .subtract(1, "month")
          .endOf("month")
          .format("DD.MM.YYYY")
          .toString();

        if (today === this.periodStart && today === this.periodEnd) {
          this.$refs.referralsBonusesPeriod.dateValue = "Сегодня";
        } else if (yesterday === this.periodStart && yesterday === this.periodEnd) {
          this.$refs.referralsBonusesPeriod.dateValue = "Вчера";
        } else if (firstDayCurrentWeek === this.periodStart && lastDayCurrentWeek === this.periodEnd) {
          this.$refs.referralsBonusesPeriod.dateValue = "С начала недели";
        } else if (firstDayLastWeek === this.periodStart && lastDayLastWeek === this.periodEnd) {
          this.$refs.referralsBonusesPeriod.dateValue = "Прошлая неделя";
        } else if (today === this.periodEnd && sevenDayAgo === this.periodStart) {
          this.$refs.referralsBonusesPeriod.dateValue = "Последние 7 дней";
        } else if (firstDayCurrentMonth === this.periodStart && today === this.periodEnd) {
          this.$refs.referralsBonusesPeriod.dateValue = "Текущий месяц";
        } else if (firstDayLastMonth === this.periodStart && lastDayLastMonth === this.periodEnd) {
          this.$refs.referralsBonusesPeriod.dateValue = "Прошлый месяц";
        } else if (
          this.periodStart === moment().startOf("day").subtract(1, "month").format("DD.MM.YYYY").toString() &&
          today === this.periodEnd
        ) {
          this.$refs.referralsBonusesPeriod.dateValue = "Последний месяц";
        } else {
          this.$refs.referralsBonusesPeriod.dateValue = period;
        }
      }
    },

    getReferralsHistoryBonusesList() {
      const workerId = this.$route.params.id;
      const { userId } = this.$store.state;
      this.tableDataHistoryBonuses.columns = this.getTableColumnsRefferalsHistoryBonuses;
      this.$store
        .dispatch("personalEmployee/getReferralsHistoryBonusesList", {
          periodStart: this.periodStart,
          periodEnd: this.periodEnd,
          workerId,
          userId,
        })
        .then((res) => {
          if (res.status === 403) {
            this.$router
              .push({
                name: "error-403",
              })
              .catch(() => {});
          } else {
            this.tableDataHistoryBonuses.records = res.response.map((record) => ({
              date: {
                value: record.date,
              },
              accruedWrittenOff: {
                value: record.value,
              },
              name: {
                value: record.worker_name,
              },
              description: {
                value: record.description,
              },
              workerId: record.worker_id,
              accessToPersonal: record.access_to_personal,
              isShowRow: true,
            }));

            const queryFilters = {
              ...(this.periodStart === "" ? null : { periodStart: this.periodStart }),
              ...(this.periodEnd === "" ? null : { periodEnd: this.periodEnd }),
            };

            this.$router
              .replace({
                name: "personal-employee-referrals",
                query: {
                  ...queryFilters,
                },
              })
              .catch(() => {});

            setTimeout(() => {
              this.isDataLoading = false;
            }, 300);

            setTimeout(() => {
              this.setPeriodLocal();
            }, 500);
          }
        });
    },

    applyFilters() {
      this.isDataLoading = true;
      const periodStart = this.$refs.referralsBonusesPeriod.period.start.input;
      const periodEnd = this.$refs.referralsBonusesPeriod.period.end.input;
      this.periodStart = periodStart;
      this.periodEnd = periodEnd;
      this.getReferralsHistoryBonusesList();
    },

    declOfNum(n, textForms) {
      n = Math.abs(n) % 100;
      const n1 = n % 10;
      if (n > 10 && n < 20) {
        return textForms[2];
      }
      if (n1 > 1 && n1 < 5) {
        return textForms[1];
      }
      if (n1 === 1) {
        return textForms[0];
      }
      return textForms[2];
    },

    saveBroughtEmployee(value) {
      this.referralEmployeeNameLocal = value;
    },

    convertBonusesToRub(countBonuses) {
      this.bonusesCountLocal -= countBonuses;
      this.isDataLoading = true;
      this.getReferralsHistoryBonusesList();
    },
  },
};
</script>

<style lang="scss" scoped>
.referrals {
  &-header {
    margin-top: 36px;
    display: flex;
    align-items: center;

    @media screen and (max-width: 1300px) {
      flex-wrap: wrap;
    }

    @media screen and (max-width: 700px) {
      margin-top: 33px;
      flex-direction: column;
    }

    &-bonuses {
      display: flex;
      align-items: center;

      @media screen and (max-width: 1300px) {
        order: 1;
      }

      @media screen and (max-width: 700px) {
        flex-direction: column;
        width: 100%;
      }

      &-count {
        font-weight: bold;
        font-size: 45px;
        line-height: 54px;
      }

      &-text {
        font-size: 13px;
        line-height: 16px;
        margin-left: 13px;

        @media screen and (max-width: 700px) {
          margin-left: 0;
        }
      }

      &-convert {
        margin-left: 27px;
        max-width: 170px;

        @media screen and (max-width: 700px) {
          max-width: 100%;
          width: 100%;
          margin: 16px 0 0 0;
        }
      }
    }

    &-referral {
      display: flex;
      align-items: center;
      margin-left: auto;

      @media screen and (max-width: 1300px) {
        order: 3;
        width: 100%;
        margin-top: 17px;
      }

      @media screen and (max-width: 700px) {
        order: 2;
        flex-direction: column;
        justify-content: center;
        margin-top: 23px;
      }

      &-empty {
        @media screen and (max-width: 700px) {
          flex-direction: row;
        }
      }

      &-text {
        font-size: 13px;
        line-height: 16px;
      }

      &-employee {
        display: flex;
        align-items: center;

        &-name {
          cursor: pointer;
          margin-left: 5px;
          color: #0066ff;
          font-size: 13px;
          line-height: 16px;

          &:hover {
            text-decoration: none;
            color: #003f9d;
          }
        }

        &-edit {
          margin-left: 5px;

          &-empty {
            margin-left: 3px;
          }
        }
      }
    }

    &-link-to-questionnaire {
      margin-left: 28px;

      @media screen and (max-width: 1300px) {
        order: 2;
        margin-left: auto;
      }

      @media screen and (max-width: 700px) {
        margin: 21px 0 0 0;
        order: 3;
      }
    }
  }

  &-description {
    max-width: 565px;
    margin-top: 26px;

    @media screen and (max-width: 700px) {
      margin-top: 29px;
      max-width: 100%;
    }

    &-text {
      font-size: 15px;
      line-height: 140%;

      @media screen and (max-width: 700px) {
        font-size: 13px;
        line-height: 130%;
      }

      &:last-child {
        margin-top: 19px;

        @media screen and (max-width: 700px) {
          margin-top: 16px;
        }
      }
    }
  }

  &-brought-employees {
    margin-top: 21px;
    max-width: 961px;

    &-title {
      font-weight: 500;
      font-size: 18px;
      line-height: 22px;

      @media screen and (max-width: 700px) {
        font-size: 15px;
        line-height: 18px;
      }
    }

    &-table {
      width: 100%;
      margin-top: 20px;

      @media screen and (max-width: 700px) {
        margin-top: -8px;
        width: calc(100% + 40px);
        max-width: calc(100% + 40px);

        ::v-deep & .c-table__cell {
          min-width: 200px;
        }
      }
    }
  }

  &-bonuses {
    margin-top: 36px;
    max-width: 961px;

    &-title {
      font-weight: 500;
      font-size: 18px;
      line-height: 22px;

      @media screen and (max-width: 700px) {
        font-size: 15px;
        line-height: 18px;
      }
    }

    &-filters {
      display: flex;
      align-items: flex-end;
      margin-top: 21px;

      @media screen and (max-width: 700px) {
        flex-direction: column;
      }

      &-period {
        &-disabled {
          opacity: 0.6;
          pointer-events: none;
        }

        @media screen and (max-width: 700px) {
          width: 100%;
        }

        ::v-deep & .c-input-container_period {
          transform: none;
          left: 0;
          @media screen and (max-width: 805px) {
            left: -30px;
          }
          @media screen and (max-width: 767px) {
            left: 0;
          }
        }
      }

      &-apply {
        margin-left: 33px;
        max-width: 130px;

        @media screen and (max-width: 700px) {
          margin: 24px 0 0 0;
          max-width: 100%;
          width: 100%;
        }
      }
    }

    &-table {
      width: 100%;
      margin-top: 25px;

      @media screen and (max-width: 700px) {
        margin-top: 7px;
        width: calc(100% + 40px);
        max-width: calc(100% + 40px);

        ::v-deep & .c-table__cell {
          min-width: 200px;
        }
      }
    }
  }

  &-loader {
    margin-top: 36px;

    @media screen and (max-width: 700px) {
      ::v-deep & .loader-overlay {
        width: calc(100% + 40px);
        left: -20px;
        border-right: none;
        border-left: none;
      }
    }
  }
}
</style>
